// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/CIUDAD_ENCANTADA_HEADER_SECTION_BACKGROUND.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header-Background-CLE {
  background-size: cover;
  /* Ajusta la imagen para cubrir todo el contenedor */
  background-position: center;
  /* Centra la imagen de fondo */
  height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  display: flex;
  flex-direction: column;
}
@media (max-width: 900px) {
  .Header-Background-CLE {
    padding-top: 10em;
    height: 80vh;
    margin-bottom: 49em;
  }
}
@media (max-width: 1000px) {
  .Header-Background-CLE {
    height: 100vh;
  }
}
@media (max-height: 700px) {
  .Header-Background-CLE {
    padding-top: 5em;
    margin-bottom: -5em;
  }
}
.Header-Background-CLE .Bottoom-box-caracteristicas {
  width: 88.5%;
  min-height: 300px;
  position: absolute;
  margin-left: 0;
  bottom: -225px;
}
@media (max-width: 900px) {
  .Header-Background-CLE .Bottoom-box-caracteristicas {
    width: 85%;
    position: relative;
    bottom: -275px;
  }
}
.Header-Background-CLE .Bottoom-box-caracteristicas .grid-item-card {
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@media (max-width: 900px) {
  .Header-Background-CLE .Bottoom-box-caracteristicas .grid-item-card {
    padding: 40px 0 30px;
  }
}
.Header-Background-CLE .Bottoom-box-caracteristicas .grid-item-card img {
  margin-bottom: 20px;
}
@media (max-width: 900px) {
  .Header-Background-CLE .Bottoom-box-caracteristicas .grid-item-card img {
    max-height: 55px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Sections/Header/HeaderSection.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,oDAAA;EACA,2BAAA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;AADF;AAKE;EAdF;IAeI,iBAAA;IACA,YAAA;IACA,mBAAA;EAFF;AACF;AAIE;EApBF;IAqBI,aAAA;EADF;AACF;AAGE;EAxBF;IAyBI,gBAAA;IACA,mBAAA;EAAF;AACF;AAEE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;AAAJ;AAEI;EAPF;IAQI,UAAA;IACA,kBAAA;IACA,cAAA;EACJ;AACF;AACI;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;EACA,yDAAA;AACN;AAEM;EATF;IAUI,oBAAA;EACN;AACF;AACM;EACE,mBAAA;AACR;AACQ;EAHF;IAII,gBAAA;EAER;AACF","sourcesContent":["@import \"~/src/utils/scss/index.scss\";\n\n.Header-Background-CLE {\n  background-size: cover;\n  /* Ajusta la imagen para cubrir todo el contenedor */\n  background-position: center;\n  /* Centra la imagen de fondo */\n  height: 100vh;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-end;\n  display: flex;\n  flex-direction: column;\n  //padding-top: 5em;\n  //margin-bottom: -5em;\n\n  @media (max-width: 900px) {\n    padding-top: 10em;\n    height: 80vh;\n    margin-bottom: 49em;\n  }\n\n  @media (max-width: 1000px) {\n    height: 100vh;\n  }\n\n  @media (max-height: 700px) {\n    padding-top: 5em;\n    margin-bottom: -5em;\n  }\n\n  .Bottoom-box-caracteristicas {\n    width: 88.5%;\n    min-height: 300px;\n    position: absolute;\n    margin-left: 0;\n    bottom: -225px;\n\n    @media (max-width: 900px) {\n      width: 85%;\n      position: relative;\n      bottom: -275px;\n    }\n\n    .grid-item-card {\n      justify-content: center;\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n      padding: 0;\n      background-image: url($Header_Section_Background);\n\n\n      @media (max-width: 900px) {\n        padding: 40px 0 30px;\n      }\n\n      img {\n        margin-bottom: 20px;\n\n        @media (max-width: 900px) {\n          max-height: 55px;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
